import React, { Component } from "react";
import { connect } from "react-redux";
import { openSignUpModal } from "../../actions/generalActions";
import history from "../../config/history";
import { fetchActivity } from "../../actions/activityActions";
import { Badge } from "react-bootstrap";

export class ActivityCard extends Component {
  handleDownloadActivity = async (isFreeActivity, activityId, title) => {
    if (!this.props.userStatus?.isLoggedIn) {
      // user not logged in
      if (!isFreeActivity) {
        // clicked on premium activity so ask to login and pay
        // alert("log in and go premium to view this paid content");
        this.props.openSignUpModal();
      } else {
        // clicked on free activity so ask to login only
        // alert("log in to view this free content");
        this.props.openSignUpModal();
      }
    } else {
      // user is logged in
      if (this.props.userStatus?.isPremium) {
        // user is premium so play the activity
        const activityLink = await this.props.fetchActivity(activityId);
        if (!this.props.error) this.handleDownload(activityLink, title);
      } else if (!isFreeActivity && !this.props.userStatus?.isPremium) {
        // user not premium and activity is not free activity ask to buy membership
        this.props.handleShowSubscribeModal();
      } else if (isFreeActivity && !this.props.userStatus?.isPremium) {
        // user not premium but activity is free so play the activity
        // alert("not premium but watch this free activity");
        const activityLink = await this.props.fetchActivity(activityId);

        if (!this.props.error) this.handleDownload(activityLink);
      }
    }
  };

  handleDownload = async (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  render() {
    return (
      <div>
        <div className="activity-card-wrapper">
          <img
            className="activity-card-img"
            src={this.props?.activity?.thumbnailLink}
            onLoad={this.props.onActivityImgsLoad}
            alt={`thumbnail for ${this.props?.activity?.title}`}
            width="1654"
            height="2339"
          />

          <Badge
            className="activities-card-badge"
          >
            {this.props?.activity?.category}
          </Badge>

          <div className="activity-card-overlay">
            <div
              className="ds-btn-primary ds-btn--sm activity-card-download-btn"
              variant=""
              onClick={() =>
                this.handleDownloadActivity(
                  this.props?.activity?.isFreeActivity,
                  this.props?.activity?._id,
                  this.props?.activity?.title
                )
              }
            >
              <i className="lni lni-download activity-card-download-icon"></i>{" "}
              PDF
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activityLink: state.activities.activityLink,
  error: state.activities?.error,
  userStatus: state.userLoggedinAndPremiumCheck,
});

export default connect(mapStateToProps, { fetchActivity, openSignUpModal })(
  ActivityCard
);
